export const forcedAppUpdate = {
  'force-update.title': 'It’s time to upgrade',
  'force-update.text':
    'Your app is outdated. Please upgrade to the last app version.',
  'force-update.cta': 'Upgrade now',
};
